// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bodoni+Moda:opsz,wght@6..96,400;6..96,500;6..96,600&family=Manrope:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.0.11 | MIT License | https://tailwindcss.com */
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --color-red-600: oklch(0.577 0.245 27.325);
    --color-blue-600: oklch(0.546 0.245 262.881);
    --color-gray-50: oklch(0.985 0.002 247.839);
    --color-gray-100: oklch(0.967 0.003 264.542);
    --color-gray-200: oklch(0.928 0.006 264.531);
    --color-gray-300: oklch(0.872 0.01 258.338);
    --color-gray-500: oklch(0.551 0.027 264.364);
    --color-gray-600: oklch(0.446 0.03 256.802);
    --color-gray-700: oklch(0.373 0.034 259.733);
    --color-gray-800: oklch(0.278 0.033 256.848);
    --color-black: #000;
    --color-white: #fff;
    --spacing: 0.25rem;
    --container-sm: 24rem;
    --container-md: 28rem;
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --radius-md: 0.375rem;
    --radius-lg: 0.5rem;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-font-feature-settings: var(--font-sans--font-feature-settings);
    --default-font-variation-settings: var(
      --font-sans--font-variation-settings
    );
    --default-mono-font-family: var(--font-mono);
    --default-mono-font-feature-settings: var(
      --font-mono--font-feature-settings
    );
    --default-mono-font-variation-settings: var(
      --font-mono--font-variation-settings
    );
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var( --default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" );
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var( --default-font-variation-settings, normal );
    -webkit-tap-highlight-color: transparent;
  }
  body {
    line-height: inherit;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var( --default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace );
    font-feature-settings: var( --default-mono-font-feature-settings, normal );
    font-variation-settings: var( --default-mono-font-variation-settings, normal );
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
    color: color-mix(in oklab, currentColor 50%, transparent);
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .visible {
    visibility: visible;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .inset-0 {
    inset: calc(var(--spacing) * 0);
  }
  .top-3 {
    top: calc(var(--spacing) * 3);
  }
  .right-3 {
    right: calc(var(--spacing) * 3);
  }
  .z-10 {
    z-index: 10;
  }
  .container {
    width: 100%;
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .mx-auto {
    margin-inline: auto;
  }
  .my-2 {
    margin-block: calc(var(--spacing) * 2);
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2);
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4);
  }
  .mt-6 {
    margin-top: calc(var(--spacing) * 6);
  }
  .mb-2 {
    margin-bottom: calc(var(--spacing) * 2);
  }
  .mb-4 {
    margin-bottom: calc(var(--spacing) * 4);
  }
  .mb-6 {
    margin-bottom: calc(var(--spacing) * 6);
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .h-4 {
    height: calc(var(--spacing) * 4);
  }
  .h-6 {
    height: calc(var(--spacing) * 6);
  }
  .h-24 {
    height: calc(var(--spacing) * 24);
  }
  .h-full {
    height: 100%;
  }
  .min-h-screen {
    min-height: 100vh;
  }
  .w-1\\/2 {
    width: calc(1/2 * 100%);
  }
  .w-4 {
    width: calc(var(--spacing) * 4);
  }
  .w-6 {
    width: calc(var(--spacing) * 6);
  }
  .w-11 {
    width: calc(var(--spacing) * 11);
  }
  .w-24 {
    width: calc(var(--spacing) * 24);
  }
  .w-30 {
    width: calc(var(--spacing) * 30);
  }
  .w-70 {
    width: calc(var(--spacing) * 70);
  }
  .w-full {
    width: 100%;
  }
  .max-w-md {
    max-width: var(--container-md);
  }
  .max-w-sm {
    max-width: var(--container-sm);
  }
  .min-w-10 {
    min-width: calc(var(--spacing) * 10);
  }
  .flex-1 {
    flex: 1;
  }
  .flex-grow {
    flex-grow: 1;
  }
  .translate-x-1 {
    --tw-translate-x: calc(var(--spacing) * 1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-6 {
    --tw-translate-x: calc(var(--spacing) * 6);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .transform {
    transform: var(--tw-rotate-x) var(--tw-rotate-y) var(--tw-rotate-z) var(--tw-skew-x) var(--tw-skew-y);
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .flex-col {
    flex-direction: column;
  }
  .items-center {
    align-items: center;
  }
  .items-stretch {
    align-items: stretch;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .space-y-4 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-x-2 {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));
    }
  }
  .space-x-4 {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 4) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-x-reverse)));
    }
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-lg {
    border-radius: var(--radius-lg);
  }
  .rounded-md {
    border-radius: var(--radius-md);
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-b-2 {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 2px;
  }
  .border-black {
    border-color: var(--color-black);
  }
  .border-gray-200 {
    border-color: var(--color-gray-200);
  }
  .bg-black {
    background-color: var(--color-black);
  }
  .bg-black\\/40 {
    background-color: color-mix(in oklab, var(--color-black) 40%, transparent);
  }
  .bg-gray-50 {
    background-color: var(--color-gray-50);
  }
  .bg-gray-100 {
    background-color: var(--color-gray-100);
  }
  .bg-gray-300 {
    background-color: var(--color-gray-300);
  }
  .bg-white {
    background-color: var(--color-white);
  }
  .object-cover {
    object-fit: cover;
  }
  .p-2 {
    padding: calc(var(--spacing) * 2);
  }
  .p-4 {
    padding: calc(var(--spacing) * 4);
  }
  .p-6 {
    padding: calc(var(--spacing) * 6);
  }
  .px-1 {
    padding-inline: calc(var(--spacing) * 1);
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .py-1 {
    padding-block: calc(var(--spacing) * 1);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .text-2xl {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xl {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .text-black {
    color: var(--color-black);
  }
  .text-blue-600 {
    color: var(--color-blue-600);
  }
  .text-gray-500 {
    color: var(--color-gray-500);
  }
  .text-gray-600 {
    color: var(--color-gray-600);
  }
  .text-gray-700 {
    color: var(--color-gray-700);
  }
  .text-gray-800 {
    color: var(--color-gray-800);
  }
  .text-red-600 {
    color: var(--color-red-600);
  }
  .text-white {
    color: var(--color-white);
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-50 {
    opacity: 50%;
  }
  .opacity-100 {
    opacity: 100%;
  }
  .shadow-lg {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-md {
    --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .duration-500 {
    --tw-duration: 500ms;
    transition-duration: 500ms;
  }
  .hover\\:bg-gray-800 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-800);
      }
    }
  }
  .focus\\:outline-none {
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .md\\:mt-0 {
    @media (width >= 48rem) {
      margin-top: calc(var(--spacing) * 0);
    }
  }
  .md\\:grid-cols-2 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
}
:root {
  --mg-ink: #17201c;
  --mg-muted: #666b68;
  --mg-green: #173b2e;
  --mg-green-hover: #214d3c;
  --mg-brass: #987348;
  --mg-line: rgba(23, 32, 28, 0.14);
  --mg-soft: #f7f6f3;
  --mg-serif: 'Bodoni Moda', 'Times New Roman', Times, serif;
  --mg-sans: 'Manrope', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
html {
  max-width: 100%;
  overflow-x: clip;
  scrollbar-gutter: stable;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}
body {
  background: #ffffff;
  color: var(--mg-ink);
  margin: 0;
  max-width: 100%;
  overflow-x: clip;
  font-family: var(--mg-sans);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
.container {
  padding: 20px;
}
@media (max-width: 768px) {
  .container {
    padding: 10px;
  }
  .card {
    margin-bottom: 20px;
  }
}
@media (max-width: 576px) {
  .card {
    margin: 10px;
  }
}
button,
input,
select,
textarea {
  font: inherit;
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
  initial-value: rotateX(0);
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
  initial-value: rotateY(0);
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
  initial-value: rotateZ(0);
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
  initial-value: skewX(0);
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
  initial-value: skewY(0);
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-space-x-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,iEAoEA;AApEA,yCAoEA;AApEA;EAAA;IAAA;6DAoEA;IApEA;8BAoEA;IApEA,0CAoEA;IApEA,4CAoEA;IApEA,2CAoEA;IApEA,4CAoEA;IApEA,4CAoEA;IApEA,2CAoEA;IApEA,4CAoEA;IApEA,2CAoEA;IApEA,4CAoEA;IApEA,4CAoEA;IApEA,mBAoEA;IApEA,mBAoEA;IApEA,kBAoEA;IApEA,qBAoEA;IApEA,qBAoEA;IApEA,mBAoEA;IApEA,0CAoEA;IApEA,mBAoEA;IApEA,0CAoEA;IApEA,kBAoEA;IApEA,yCAoEA;IApEA,kBAoEA;IApEA,sCAoEA;IApEA,yBAoEA;IApEA,2BAoEA;IApEA,uBAoEA;IApEA,qBAoEA;IApEA,mBAoEA;IApEA,oCAoEA;IApEA,kEAoEA;IApEA,uCAoEA;IApEA,wEAoEA;IApEA;;KAoEA;IApEA,4CAoEA;IApEA;;KAoEA;IApEA;;KAoEA;EAAA;AAAA;AApEA;EAAA;IAAA,sBAoEA;IApEA,SAoEA;IApEA,UAoEA;IApEA,eAoEA;EAAA;EApEA;IAAA,gBAoEA;IApEA,8BAoEA;IApEA,WAoEA;IApEA,6JAoEA;IApEA,mEAoEA;IApEA,yEAoEA;IApEA,wCAoEA;EAAA;EApEA;IAAA,oBAoEA;EAAA;EApEA;IAAA,SAoEA;IApEA,cAoEA;IApEA,qBAoEA;EAAA;EApEA;IAAA,yCAoEA;IApEA,iCAoEA;EAAA;EApEA;IAAA,kBAoEA;IApEA,oBAoEA;EAAA;EApEA;IAAA,cAoEA;IApEA,gCAoEA;IApEA,wBAoEA;EAAA;EApEA;IAAA,mBAoEA;EAAA;EApEA;IAAA,kJAoEA;IApEA,0EAoEA;IApEA,8EAoEA;IApEA,cAoEA;EAAA;EApEA;IAAA,cAoEA;EAAA;EApEA;IAAA,cAoEA;IApEA,cAoEA;IApEA,kBAoEA;IApEA,wBAoEA;EAAA;EApEA;IAAA,eAoEA;EAAA;EApEA;IAAA,WAoEA;EAAA;EApEA;IAAA,cAoEA;IApEA,qBAoEA;IApEA,yBAoEA;EAAA;EApEA;IAAA,aAoEA;EAAA;EApEA;IAAA,wBAoEA;EAAA;EApEA;IAAA,kBAoEA;EAAA;EApEA;IAAA,gBAoEA;EAAA;EApEA;IAAA,cAoEA;IApEA,sBAoEA;EAAA;EApEA;IAAA,eAoEA;IApEA,YAoEA;EAAA;EApEA;IAAA,aAoEA;IApEA,8BAoEA;IApEA,gCAoEA;IApEA,uBAoEA;IApEA,cAoEA;IApEA,gBAoEA;IApEA,6BAoEA;IApEA,UAoEA;EAAA;EApEA;IAAA,mBAoEA;EAAA;EApEA;IAAA,0BAoEA;EAAA;EApEA;IAAA,sBAoEA;EAAA;EApEA;IAAA,UAoEA;IApEA,yDAoEA;EAAA;EApEA;IAAA,gBAoEA;EAAA;EApEA;IAAA,wBAoEA;EAAA;EApEA;IAAA,eAoEA;IApEA,mBAoEA;EAAA;EApEA;IAAA,oBAoEA;EAAA;EApEA;IAAA,UAoEA;EAAA;EApEA;IAAA,gBAoEA;EAAA;EApEA;IAAA,gBAoEA;EAAA;EApEA;IAAA,kBAoEA;EAAA;EApEA;IAAA,YAoEA;EAAA;EApEA;IAAA,wBAoEA;EAAA;AAAA;AApEA;EAAA;IAAA,mBAoEA;EAAA;EApEA;IAAA,kBAoEA;EAAA;EApEA;IAAA,eAoEA;EAAA;EApEA;IAAA,kBAoEA;EAAA;EApEA;IAAA,gBAoEA;EAAA;EApEA;IAAA,+BAoEA;EAAA;EApEA;IAAA,6BAoEA;EAAA;EApEA;IAAA,+BAoEA;EAAA;EApEA;IAAA,WAoEA;EAAA;EApEA;IAAA,WAoEA;IApEA;MAAA,gBAoEA;IAAA;IApEA;MAAA,gBAoEA;IAAA;IApEA;MAAA,gBAoEA;IAAA;IApEA;MAAA,gBAoEA;IAAA;IApEA;MAAA,gBAoEA;IAAA;EAAA;EApEA;IAAA,mBAoEA;EAAA;EApEA;IAAA,sCAoEA;EAAA;EApEA;IAAA,oCAoEA;EAAA;EApEA;IAAA,oCAoEA;EAAA;EApEA;IAAA,oCAoEA;EAAA;EApEA;IAAA,uCAoEA;EAAA;EApEA;IAAA,uCAoEA;EAAA;EApEA;IAAA,uCAoEA;EAAA;EApEA;IAAA,aAoEA;EAAA;EApEA;IAAA,aAoEA;EAAA;EApEA;IAAA,aAoEA;EAAA;EApEA;IAAA,qBAoEA;EAAA;EApEA;IAAA,oBAoEA;EAAA;EApEA;IAAA,gCAoEA;EAAA;EApEA;IAAA,gCAoEA;EAAA;EApEA;IAAA,iCAoEA;EAAA;EApEA;IAAA,YAoEA;EAAA;EApEA;IAAA,iBAoEA;EAAA;EApEA;IAAA,uBAoEA;EAAA;EApEA;IAAA,+BAoEA;EAAA;EApEA;IAAA,+BAoEA;EAAA;EApEA;IAAA,gCAoEA;EAAA;EApEA;IAAA,gCAoEA;EAAA;EApEA;IAAA,gCAoEA;EAAA;EApEA;IAAA,gCAoEA;EAAA;EApEA;IAAA,WAoEA;EAAA;EApEA;IAAA,8BAoEA;EAAA;EApEA;IAAA,8BAoEA;EAAA;EApEA;IAAA,oCAoEA;EAAA;EApEA;IAAA,OAoEA;EAAA;EApEA;IAAA,YAoEA;EAAA;EApEA;IAAA,0CAoEA;IApEA,sDAoEA;EAAA;EApEA;IAAA,0CAoEA;IApEA,sDAoEA;EAAA;EApEA;IAAA,qGAoEA;EAAA;EApEA;IAAA,eAoEA;EAAA;EApEA;IAAA,gDAoEA;EAAA;EApEA;IAAA,sBAoEA;EAAA;EApEA;IAAA,mBAoEA;EAAA;EApEA;IAAA,oBAoEA;EAAA;EApEA;IAAA,8BAoEA;EAAA;EApEA;IAAA,uBAoEA;EAAA;EApEA;IAAA,6BAoEA;EAAA;EApEA;IAAA,6BAoEA;EAAA;EApEA;IAAA;MAAA,uBAoEA;MApEA,8EAoEA;MApEA,sFAoEA;IAAA;EAAA;EApEA;IAAA;MAAA,uBAoEA;MApEA,+EAoEA;MApEA,uFAoEA;IAAA;EAAA;EApEA;IAAA;MAAA,uBAoEA;MApEA,+EAoEA;MApEA,uFAoEA;IAAA;EAAA;EApEA;IAAA,gBAoEA;EAAA;EApEA;IAAA,sBAoEA;EAAA;EApEA;IAAA,mCAoEA;EAAA;EApEA;IAAA,+BAoEA;EAAA;EApEA;IAAA,+BAoEA;EAAA;EApEA;IAAA,oCAoEA;IApEA,iBAoEA;EAAA;EApEA;IAAA,2CAoEA;IApEA,wBAoEA;EAAA;EApEA;IAAA,2CAoEA;IApEA,wBAoEA;EAAA;EApEA;IAAA,gCAoEA;EAAA;EApEA;IAAA,mCAoEA;EAAA;EApEA;IAAA,oCAoEA;EAAA;EApEA;IAAA,0EAoEA;EAAA;EApEA;IAAA,sCAoEA;EAAA;EApEA;IAAA,uCAoEA;EAAA;EApEA;IAAA,uCAoEA;EAAA;EApEA;IAAA,oCAoEA;EAAA;EApEA;IAAA,iBAoEA;EAAA;EApEA;IAAA,iCAoEA;EAAA;EApEA;IAAA,iCAoEA;EAAA;EApEA;IAAA,iCAoEA;EAAA;EApEA;IAAA,wCAoEA;EAAA;EApEA;IAAA,wCAoEA;EAAA;EApEA;IAAA,wCAoEA;EAAA;EApEA;IAAA,uCAoEA;EAAA;EApEA;IAAA,uCAoEA;EAAA;EApEA;IAAA,uCAoEA;EAAA;EApEA;IAAA,kBAoEA;EAAA;EApEA;IAAA,gBAoEA;EAAA;EApEA;IAAA,0BAoEA;IApEA,4DAoEA;EAAA;EApEA;IAAA,yBAoEA;IApEA,2DAoEA;EAAA;EApEA;IAAA,yBAoEA;IApEA,2DAoEA;EAAA;EApEA;IAAA,yBAoEA;IApEA,2DAoEA;EAAA;EApEA;IAAA,yCAoEA;IApEA,oCAoEA;EAAA;EApEA;IAAA,2CAoEA;IApEA,sCAoEA;EAAA;EApEA;IAAA,6CAoEA;IApEA,wCAoEA;EAAA;EApEA;IAAA,yBAoEA;EAAA;EApEA;IAAA,4BAoEA;EAAA;EApEA;IAAA,4BAoEA;EAAA;EApEA;IAAA,4BAoEA;EAAA;EApEA;IAAA,4BAoEA;EAAA;EApEA;IAAA,4BAoEA;EAAA;EApEA;IAAA,2BAoEA;EAAA;EApEA;IAAA,yBAoEA;EAAA;EApEA;IAAA,WAoEA;EAAA;EApEA;IAAA,YAoEA;EAAA;EApEA;IAAA,aAoEA;EAAA;EApEA;IAAA,+HAoEA;IApEA,sIAoEA;EAAA;EApEA;IAAA,6HAoEA;IApEA,sIAoEA;EAAA;EApEA;IAAA,mRAoEA;IApEA,qFAoEA;IApEA,2EAoEA;EAAA;EApEA;IAAA,4BAoEA;IApEA,qFAoEA;IApEA,2EAoEA;EAAA;EApEA;IAAA,oBAoEA;IApEA,0BAoEA;EAAA;EApEA;IAAA;MAAA;QAAA,uCAoEA;MAAA;IAAA;EAAA;EApEA;IAAA;MAAA,wBAoEA;MApEA,mBAoEA;IAAA;EAAA;EApEA;IAAA;MAAA,oCAoEA;IAAA;EAAA;EApEA;IAAA;MAAA,gDAoEA;IAAA;EAAA;AAAA;AApEA;EAAA,iBAoEA;EApEA,mBAoEA;EApEA,mBAoEA;EApEA,yBAoEA;EApEA,mBAoEA;EApEA,iCAoEA;EApEA,kBAoEA;EApEA,0DAoEA;EApEA,oEAoEA;AAAA;AApEA;EAAA,eAoEA;EApEA,gBAoEA;EApEA,wBAoEA;AAAA;AApEA;;;EAAA,sBAoEA;AAAA;AApEA;EAAA,mBAoEA;EApEA,oBAoEA;EApEA,SAoEA;EApEA,eAoEA;EApEA,gBAoEA;EApEA,2BAoEA;EApEA,mCAoEA;EApEA,kCAoEA;AAAA;AApEA;EAAA;aAoEA;AAAA;AApEA;EAAA,aAoEA;AAAA;AApEA;EAAA;IAAA,aAoEA;EAAA;EApEA;IAAA,mBAoEA;EAAA;AAAA;AApEA;EAAA;IAAA,YAoEA;EAAA;AAAA;AApEA;;;;EAAA,aAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;EApEA,gBAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;EApEA,gBAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;EApEA,gBAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;EApEA,yBAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;EApEA,yBAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;EApEA,yBAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;EApEA,uBAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;EApEA,uBAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;EApEA,gBAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;EApEA,gBAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;EApEA,oBAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;EApEA,wBAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;EApEA,wBAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;EApEA,wBAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;EApEA,wBAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;AAAA;AApEA;EAAA,kBAoEA;EApEA,eAoEA;EApEA,kBAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;EApEA,mBAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;EApEA,wBAoEA;AAAA;AApEA;EAAA,WAoEA;EApEA,eAoEA;AAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Bodoni+Moda:opsz,wght@6..96,400;6..96,500;6..96,600&family=Manrope:wght@400;500;600;700&display=swap');\n@import \"tailwindcss\";\n\n:root {\n  --mg-ink: #17201c;\n  --mg-muted: #666b68;\n  --mg-green: #173b2e;\n  --mg-green-hover: #214d3c;\n  --mg-brass: #987348;\n  --mg-line: rgba(23, 32, 28, 0.14);\n  --mg-soft: #f7f6f3;\n  --mg-serif: 'Bodoni Moda', 'Times New Roman', Times, serif;\n  --mg-sans: 'Manrope', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n\nhtml {\n  max-width: 100%;\n  overflow-x: clip;\n  scrollbar-gutter: stable;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nbody {\n  background: #ffffff;\n  color: var(--mg-ink);\n  margin: 0;\n  max-width: 100%;\n  overflow-x: clip;\n  font-family: var(--mg-sans);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n.container {\n  padding: 20px;\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 10px;\n  }\n\n  .card {\n    margin-bottom: 20px;\n  }\n}\n\n@media (max-width: 576px) {\n  .card {\n    margin: 10px;\n  }\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  font: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
